import { useState, useEffect } from 'react';
import axios from 'axios';
import { useLanguage } from './useLanguage';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useComponents = (category = null) => {
  const [components, setComponents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { currentLanguage } = useLanguage();

  const fetchComponents = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = category ? `${API}/components?category=${category}` : `${API}/components`;
      const response = await axios.get(url);
      setComponents(response.data);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching components:', err);
    } finally {
      setLoading(false);
    }
  };

  // Obtener nombre localizado del componente
  const getLocalizedName = (component) => {
    const langSuffix = currentLanguage === 'ca' ? '_ca' : currentLanguage === 'en' ? '_en' : '_es';
    return component[`name${langSuffix}`] || component.name_es || component.id;
  };

  // Obtener descripción localizada del componente
  const getLocalizedDescription = (component) => {
    const langSuffix = currentLanguage === 'ca' ? '_ca' : currentLanguage === 'en' ? '_en' : '_es';
    return component[`description${langSuffix}`] || component.description_es || '';
  };

  // Obtener label localizado de parámetro
  const getLocalizedLabel = (parameter) => {
    const langSuffix = currentLanguage === 'ca' ? '_ca' : currentLanguage === 'en' ? '_en' : '_es';
    return parameter[`label${langSuffix}`] || parameter.label_es || parameter.name;
  };

  useEffect(() => {
    fetchComponents();
  }, [category]);

  return {
    components,
    loading,
    error,
    fetchComponents,
    getLocalizedName,
    getLocalizedDescription,
    getLocalizedLabel,
  };
};
